import axios from '../services/request'

/* 考试列表 */
export const examlist = (data = {}) => axios.get('api/student/examlist',data);

/* 试卷信息 */
export const examination = (data = {}) => axios.get('api/student/examination',data);

/* 提交试卷 */
export const answer = (data = {}) => axios.post('api/examination/answer',data);

/* 更新考试时间 */
export const updateTime = (data = {}) => axios.get('api/student/updateTime',data);

/* 查看试卷 */
export const previewExam = (data = {}) => axios.get('api/student/previewExam',data);

/* 验证考试 */
export const verifyExam = (data = {}) => axios.get('api/student/verifyExam',data);

export default{
    examlist,
    examination,
    answer,
    updateTime,
    previewExam,
    verifyExam
}